import { analyticsFEA } from "src/AnalyticsFEA";
import { GarageKeyType } from "src/components/UserAccount/shared/GarageKey";
import { postTo } from "src/store/dataService/routes/shared/osfetch";

function buildVerifyAccessCodeBody(pin: string, garageKey: string, garageKeyType: string) {
    const body = {
        pin,
        type: garageKeyType === GarageKeyType.phone ? "sms" : garageKeyType,
    } as { pin: string; type: string; phone?: string; email?: string };
    if (garageKeyType === GarageKeyType.email) {
        body.email = garageKey;
    } else {
        body.phone = garageKey.replace(/[^0-9]/g, "");
    }
    return body;
}

export const verifyAccessCode = (
    account: string,
    code: string,
    garageKey: string,
    garageKeyType: string,
    isFromSignIn: boolean = false
) => {
    const body = buildVerifyAccessCodeBody(code, garageKey, garageKeyType);
    return postTo(`/accounts/${account}/auth/pin`, body).then(async (response: Response) => {
        if (!response.ok) {
            throw new Error("Unable to verify the access code");
        }
        const data = await response.json();
        const uuid = data.uuid;

        analyticsFEA.updateOSProvider(uuid);

        if (isFromSignIn) {
            analyticsFEA.engine.signInToGarageGarageIcon(uuid);
        } else {
            analyticsFEA.engine.signInComplete(uuid);
        }

        return {
            uuid,
        };
    });
};
